import React, { Fragment } from "react";
import { Line } from "react-chartjs-2";

import {
  xValues,
  tableYValuesIndex
} from "../constants/patternAcousticPerformances";
import chartOptions from "../constants/acousticPerfChartOptions";
import getPatternAcousticPerfChartData from "../utils/getPatternAcousticPerfChartData";
import getPatternRatio from "../utils/getPatternRatio";
import getPatternAcousticPerf from "../utils/getPatternAcousticPerf";
import patternAlphaSabineRatios from "../constants/patternAlphaSabineRatios";
import patternPerforationRatios from "../constants/patternPerforationRatios";

const ModelExportAcousticPerf = props => {
  const alphaSabineRatio = getPatternRatio(
    patternAlphaSabineRatios,
    props.patternId,
    props.patternConfig
  );
  const perforationRatio = getPatternRatio(
    patternPerforationRatios,
    props.patternId,
    props.patternConfig
  );
  const acousticPerformance = getPatternAcousticPerf(
    props.patternId,
    props.patternConfig
  );
  const chartData = getPatternAcousticPerfChartData(acousticPerformance);
  const patId = props.patternConfig;

  console.log (patId);
  return (
    <Fragment>
      <div className="f4 b mb2">{props.t("pdf:pdfLabelAcousticPerformance")} </div>
      {acousticPerformance && (
        <div className="flex">
          <div className="w-255 h-400">
            <Line data={chartData} options={chartOptions} />
          </div>
          <div className="acoustic-perf-modal__table acoustic-perf-modal__table--small">
            <table>
              <tbody>
                <tr>
                  <td>f (Hz)</td>
                  <td>&alpha;&rho;</td>
                </tr>
                {tableYValuesIndex.map(index => (
                  <tr key={`ap-${index}`}>
                    <td>{xValues[index]}</td>
                    <td>
                      {acousticPerformance ? acousticPerformance[index] : "--"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {!acousticPerformance && (
        <div className="">
          {props.t("pdf:pdfLabelAvailableSoon")} <br />
          <br />
        </div>
      )}

      <div className="flex f7">
        <div className="mr4">
          <span className="b">{props.t("pdf:pdfLabelAcouticPerfAw")}</span>
          &nbsp;{alphaSabineRatio}
        </div>
        <div className="">
          <span className="b">{props.t("pdf:pdfLabelPerforationRate")}</span>
          &nbsp;{perforationRatio}
        </div>
      </div>
    </Fragment>
  );
};

export default ModelExportAcousticPerf;



// WEBPACK FOOTER //
// ./src/components/ModelExportAcousticPerf.js